export var EmbedActionTypes;
(function (EmbedActionTypes) {
    EmbedActionTypes["VIEWER_FEEDBACK"] = "VIEWER_FEEDBACK";
    EmbedActionTypes["CHANNEL_VIEWER_FEEDBACK"] = "CHANNEL_VIEWER_FEEDBACK";
})(EmbedActionTypes || (EmbedActionTypes = {}));
